module.exports = __webpack_public_path__ + "media/country_flags/py-854181f5.png";